import React from 'react';

import styles from './styles';

import LoadingSpinner from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';
import RecommendationList from './profileRecommendationList';
import Button, { BUTTON_SIZES, BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import StarIcon from 'buyside/svgs/star.svg';
import XMarkIcon from 'buyside/svgs/x_mark.svg';
import PencilIcon from 'buyside/svgs/pencil.svg';

import { onboardingUrl } from 'buyside/util/urlHelper';

class ProfileRecommendationCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState({ loading: true });
    this.props.handleHideFundRecommendation({
      fundRecommendationId: this.props.node.id
    });
  }

  render() {
    const { node, ProfileCard, Profile, ProfileType, ...props } = this.props;

    return (
      <div className={styles.cardArea}>
        <div className={styles.recommendationArea}>
          <div className={styles.recommendationInfo}>
            <h4>
              <StarIcon className={styles.starIcon} />
              Recommended for{' '}
              {ProfileType === 'Allocator' && node.fundProfile ? node.fundProfile.name : 'you'}{' '}
              based on:
            </h4>
            <div className={styles.typeList}>
              {ProfileType === 'Buyside' && node.matchesFundType && (
                <div className={styles.typeListItem}>
                  Firm Type: <em>{Profile.fundType}</em>
                </div>
              )}
              {ProfileType === 'Buyside' && node.matchesStrategy && (
                <div className={styles.typeListItem}>
                  Strategy: <em>{Profile.strategy}</em>
                </div>
              )}
              {node.matchesAumRange && Profile.aumRange && (
                <div className={styles.typeListItem}>
                  Aum Range: <em>{Profile.aumRange}</em>
                </div>
              )}
              {node.matchesGeographies && node.geographiesMatching && (
                <RecommendationList title="Geographies" listItems={node.geographiesMatching} />
              )}
              {node.matchesSectors && node.sectorsMatching && (
                <RecommendationList title="Sectors" listItems={node.sectorsMatching} />
              )}
              {node.matchesAssetClasses && node.assetClassesMatching && (
                <RecommendationList title="Asset Classes" listItems={node.assetClassesMatching} />
              )}
            </div>
          </div>
          <div className={styles.actionsArea}>
            <Button
              text="Remove from recommendations"
              onClick={this.handleClick}
              className={styles.actionButton}
              size={BUTTON_SIZES.TINY}
              type={BUTTON_TYPES.LINK}
              icon={XMarkIcon}
              iconStyle={styles.actionIcon}
            />
            {ProfileType === 'Buyside' && (
              <Button
                text="Edit recommendation preferences"
                className={styles.actionButton}
                size={BUTTON_SIZES.TINY}
                type={BUTTON_TYPES.LINK}
                icon={PencilIcon}
                iconStyle={styles.actionIcon}
                url={onboardingUrl()}
              />
            )}
          </div>
        </div>
        {ProfileCard && <ProfileCard node={Profile} {...props} />}
        {this.state.loading && (
          <div className={styles.loadingArea}>
            <div className={styles.spinner}>
              <LoadingSpinner size="medium" />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ProfileRecommendationCard;
